<!-- <a *ngIf="!menuItem.externalLink&&!menuItem.contentPage" class="menu-title" (click)="navigateToInternalLink(menuItem)">{{'header.'+ menuItem.name | translate | translateKey}}&nbsp;&nbsp; 
    <i *ngIf="menuItem.childs&&menuItem.childs.length>0"  [ngClass]="{'fa-caret-right':level>1,'right-arrow':level>1}" class="fa fa-caret-down" aria-hidden="true"></i>
</a>
<a *ngIf="!menuItem.externalLink&&menuItem.contentPage" class="menu-title"   [routerLink]="isoCodeThree+'/corporate/pages/'+menuItem.slug" >{{'header.'+ menuItem.name | translate | translateKey}}&nbsp;&nbsp; 
    <i *ngIf="menuItem.childs &&menuItem.childs.length>0" [ngClass]="{'fa-caret-right':level>1,'right-arrow':level>1}" class="fa fa-caret-down" aria-hidden="true"></i>
</a>
<a *ngIf="menuItem.externalLink" class="menu-title"   (click)="navigateToModule(menuItem)"  >{{'header.'+ menuItem.name | translate | translateKey}}&nbsp;&nbsp; 
    <i *ngIf="menuItem.childs &&menuItem.childs.length>0" [ngClass]="{'fa-caret-right':level>1,'right-arrow':level>1}" class="fa fa-caret-down" aria-hidden="true"></i>
</a>

<ul [class.sub-child]="level>1"  class="child" *ngIf="menuItem.childs&&menuItem.childs.length>0">
    <li class="parent" app-submenu [menuItem]="submenu" [level]="level+1" *ngFor="let submenu of menuItem.childs|sort:'sortOrder'">
    </li>
</ul> -->

<div class="push-menu push-menu--hide" [class.slide-left]="level > 0 && level%2 === 0">
    <ng-container *ngTemplateOutlet="pushMenuTemplate;context:{$implicit:menuItems,menuName:menuName}">
    </ng-container>
</div>
<div class="push-menu push-menu--hide" [class.slide-left]="level > 0 && level%2 !== 0">
    <ng-container *ngTemplateOutlet="pushMenuTemplate;context:{$implicit:menuItems,menuName:menuName}">
    </ng-container>
</div>
<ng-template #pushMenuTemplate let-menuItems let-title="menuName">
    <div class="push-menu__heading">
        <span (click)="goBack(level)">
            <span class="fa fa-chevron-left"></span> {{'header.'+title|translate|translateKey}}
        </span>
    </div>
    <div class="">
        <ul class="list-unstyled push-menu__list" role="menuitem">
            <li class="push-menu__list-item" (click)="itemClicked(submenu)" tabindex="0" attr.aria-label="training" *ngFor="let submenu of menuItems">
                <a tabindex="0">
                    <span> {{'megamenu.'+submenu.name |translate|translateKey}}</span>
                    <span class="fa fa-chevron-right float-right" *ngIf="submenu.childs && submenu.childs.length > 0"></span>
                </a>
            </li>
        </ul>
    </div>
</ng-template>